import React, { Component } from 'react';
import AccountTimesheetTable from "./AccountTimesheetTable"

import moment from 'moment';

//Sort by week end date, calculate balance
let calculateBalanceAtDate = function(account) {
    let balance = account.student.awardBalance;
    if (account.timesheets) {
        return account.timesheets.map(timesheet => timesheet.balanceAtDate = balance - timesheet.weeksPay)
    }
    return false;
}


let AccountSelectPanel = ({ ...props }) => {
    let account = props.store.accounts.getById(props.accountId);

    account = account.include(["employer", "supervisor", "student", "timesheet", "timestamp"]);
    
    return (
        <div >
            <div className="card-header d-flex">
                <h3 className="h5 employer-name mr-auto">{account.employer.name}</h3>
            </div>

            <div className="card-body" style={{marginBottom:"-1em", overflowX: "scroll", overflowY: "clip"}}>
                <div className="card-title" style={{marginBottom:"-2em"}}>
                    <div className="d-flex">
                        <p className="pl-0 pr-2 pt-2 mr-2 label">
                            <strong>Supervisor: </strong>
                            <p>{account.supervisor.name}</p>
                        </p>
                        <p className="p-2 mr-2 label">
                            <strong>Secondary Supervisor(s): </strong>
                            <p>{account.getSecondarySupervisorNames()}</p>
                        </p>
                        <p className="p-2 mr-2 label">
                            <strong>Employment Start: </strong>
                            <p>{moment(account.startDate).format("l")}</p>
                        </p>
                        <p className="p-2 mr-2 label">
                            <strong>Employment End: </strong>
                            <p>{moment(account.startDate).format("l")}</p>
                        </p>
                        <p className="p-2 mr-2 label">
                            <strong>Pay Rate: </strong>
                            <p>${account.payRate.toFixed(2)}</p>
                        </p>
                        <p className="p-2 mr-2 label">
                            <strong>Fopal: </strong>
                            <p>{account.fopal}</p>
                        </p>
                    </div>
                </div>

                {account.timesheetIds.length > 0 &&
                    <AccountTimesheetTable 
                        showCertified={false}
                        showCertifiedDate={true} 
                        showSubmittedDate={true} 
                        showWeekEndDate={true}
                        accounts={[account]} 
                        store={props.store} />
                }

            </div>

        </div>
    )


}

export default AccountSelectPanel;